/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { InjectionToken } from '@angular/core';
import { ContextRouteAttachment } from '../router/context-router.interfaces';

export const CONTEXTABLE_COMPONENT = new InjectionToken<ContextableComponent>('ContextableComponent');

/**
 * Abstracts the actual parent component. Whether it is page opened by @angular/router or dialog.
 * {@link ContextableComponent} can be injected under opened route using {@link CONTEXTABLE_COMPONENT} token, like
 * <code>@Inject(CONTEXTABLE_COMPONENT) private contextable: ContextableComponent</code>.
 */
export interface ContextableComponent {
  readonly attachment: ContextRouteAttachment;

  /**
   * Typically apply is called when main workflow was completed successfully
   */
  apply(value: any): void;

  /**
   * Typically cancel is called when user requests to back the previous page/context.
   */
  cancel(): void;
}
